module.exports = "/src/views/player/help/images/army2.jpg";